import { useMutation, useQueryClient } from "@tanstack/react-query";
import { buildMonographEn } from "../api/monograph";

export function useBuildMonographEn(projectId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => buildMonographEn(projectId),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["project", projectId] });
      qc.invalidateQueries({ queryKey: ["monograph", projectId] });
    },
  });
}
